// extracted by mini-css-extract-plugin
export var bd = "br10-ab";
export var bigger = "br10-db";
export var detail = "br10-cb";
export var downloadBar = "br10-9a";
export var footBottom = "br10-8a";
export var footBottomDesc = "br10-fb";
export var footerBottom = "br10-hb";
export var ft = "br10-gb";
export var logo = "br10-bb";
export var red = "br10-eb";